module.exports = __webpack_public_path__ + "static/media/buildingConstruction31.388711a9.jpg";